(() => {
  const root = document.querySelector('[data-oo-shop-all-filters]');
  if (!root) return;

  const GROUPS = ['type', 'line', 'size', 'flavor'];
  const LINE_LABELS = new Map([
    ['Golden Owls', 'Golden Owls'],
    ['Platinum Owls', 'Platinum Owls'],
    ['Golden THCA Gummies', 'Golden THCA Gummies'],
    ['Platinum THCA Gummies', 'Platinum THCA Gummies'],
  ]);
  const LINE_ORDER = Array.from(LINE_LABELS.keys());
  const SIZE_ORDER = ['1ml', '2ml', '3ml', '4ml', '50mg', '150mg', '500mg'];
  const TYPE_LABELS = new Map([
    ['THCA Vape', 'THCA Vape'],
    ['THCA Gummies', 'THCA Gummies'],
  ]);

  const endpoint = root.dataset.productsEndpoint || '/collections/all/products.json?limit=250';
  const currency = root.dataset.currency || 'EUR';
  const grid = document.getElementById('product-grid');
  const status = root.querySelector('[data-oo-filter-status]');
  const error = root.querySelector('[data-oo-filter-error]');
  const clearButton = root.querySelector('[data-oo-clear-all]');
  const sortSelect = root.querySelector('[data-oo-sort]');
  const optionContainers = Object.fromEntries(GROUPS.map((group) => [group, root.querySelector(`[data-oo-options="${group}"]`)]));

  if (!grid) return;

  let products = [];
  const selected = Object.fromEntries(GROUPS.map((group) => [group, new Set()]));

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const money = (value) => {
    const number = Number.parseFloat(value || 0);
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(number);
    } catch (e) {
      return `€${number.toFixed(2)}`;
    }
  };

  const productPrice = (product) => {
    const prices = (product.variants || []).map((variant) => Number.parseFloat(variant.price || 0)).filter(Number.isFinite);
    return prices.length ? Math.min(...prices) : 0;
  };

  const unique = (values) => [...new Set(values.filter(Boolean))];

  const inferType = (product, text) => {
    if (/gumm/.test(text)) return 'THCA Gummies';
    if (/vape|diffuser/.test(text)) return 'THCA Vape';
    if (TYPE_LABELS.has(product.product_type)) return product.product_type;
    return '';
  };

  const inferLine = (product, text, type) => {
    const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map((v) => v.trim());
    if (type === 'THCA Gummies') {
      if (/platinum|live rosin/.test(text)) return 'Platinum THCA Gummies';
      if (/golden|distillate/.test(text)) return 'Golden THCA Gummies';
    }
    if (/platinum/.test(text)) return 'Platinum Owls';
    if (/golden/.test(text)) return 'Golden Owls';
    if (tags.includes('Platinum Owls')) return 'Platinum Owls';
    if (tags.includes('Golden Owls')) return 'Golden Owls';
    if (tags.includes('Platinum Live Rosin Gummies')) return 'Platinum THCA Gummies';
    if (tags.includes('Golden Owl Gummies')) return 'Golden THCA Gummies';
    return '';
  };

  const inferSize = (text) => SIZE_ORDER.find((size) => new RegExp(`(^|[^0-9a-z])${size.toLowerCase()}([^0-9a-z]|$)`, 'i').test(text)) || '';

  const cleanedVariantTitle = (title) => {
    const value = String(title || '').trim();
    if (!value || /default title/i.test(value)) return '';
    return value.replace(/\s*\/\s*default title$/i, '').trim();
  };

  const inferFlavors = (product, text, type) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const variantTitles = unique(variants.map((variant) => cleanedVariantTitle(variant.title || variant.option1)));
    if (variantTitles.length > 1 || (variantTitles.length === 1 && !/default/i.test(variantTitles[0]))) {
      return variantTitles;
    }
    if (type === 'THCA Vape') {
      const title = String(product.title || '');
      const match = title.match(/(?:vape|diffuser)\s*[–—-]\s*(.+)$/i);
      if (match?.[1]) return [match[1].trim()];
    }
    return [];
  };

  const normalizeProduct = (product, index) => {
    const text = `${product.title || ''} ${product.handle || ''}`.toLowerCase();
    const type = inferType(product, text);
    const line = inferLine(product, text, type);
    const size = inferSize(text);
    const flavors = inferFlavors(product, text, type);
    return { ...product, _index: index, _type: type, _line: line, _size: size, _flavors: flavors };
  };

  const valuesForGroup = (product, group) => group === 'flavor' ? product._flavors : [product[`_${group}`]].filter(Boolean);

  const sortValues = (group, values) => {
    const items = [...values];
    if (group === 'type') return items.sort((a, b) => ['THCA Vape', 'THCA Gummies'].indexOf(a) - ['THCA Vape', 'THCA Gummies'].indexOf(b));
    if (group === 'line') return items.sort((a, b) => LINE_ORDER.indexOf(a) - LINE_ORDER.indexOf(b));
    if (group === 'size') return items.sort((a, b) => {
      const ai = SIZE_ORDER.indexOf(a), bi = SIZE_ORDER.indexOf(b);
      return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
    });
    return items.sort((a, b) => a.localeCompare(b));
  };

  const displayValue = (group, value) => group === 'type' ? (TYPE_LABELS.get(value) || value) : group === 'line' ? (LINE_LABELS.get(value) || value) : value;

  const matches = (product, omittedGroup = null, candidateGroup = null, candidateValue = null) => {
    const base = GROUPS.every((group) => {
      if (group === omittedGroup) return true;
      const groupSelected = selected[group];
      if (!groupSelected.size) return true;
      return valuesForGroup(product, group).some((value) => groupSelected.has(value));
    });
    if (!base) return false;
    if (!candidateGroup) return true;
    return valuesForGroup(product, candidateGroup).includes(candidateValue);
  };

  const createOption = (group, value) => {
    const id = `oo-filter-${group}-${value.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
    const label = document.createElement('label');
    label.className = 'oo-shop-filter-option';
    label.setAttribute('for', id);
    label.innerHTML = `
      <input id="${escapeHtml(id)}" type="checkbox" value="${escapeHtml(value)}" data-oo-filter-input="${group}">
      <span>${escapeHtml(displayValue(group, value))}</span>
      <small data-oo-option-count>0</small>
    `;
    return label;
  };

  const renderOptions = () => {
    GROUPS.forEach((group) => {
      const values = new Set(products.flatMap((product) => valuesForGroup(product, group)).filter(Boolean));
      const container = optionContainers[group];
      if (!container) return;
      container.innerHTML = '';
      sortValues(group, values).forEach((value) => container.appendChild(createOption(group, value)));
    });
  };

  const readSelectedFromInputs = () => {
    GROUPS.forEach((group) => selected[group].clear());
    root.querySelectorAll('[data-oo-filter-input]:checked').forEach((input) => selected[input.dataset.ooFilterInput].add(input.value));
  };

  const updateOptionCounts = () => {
    GROUPS.forEach((group) => {
      root.querySelectorAll(`[data-oo-filter-input="${group}"]`).forEach((input) => {
        const count = products.filter((product) => matches(product, group, group, input.value)).length;
        const label = input.closest('.oo-shop-filter-option');
        const countNode = label.querySelector('[data-oo-option-count]');
        countNode.textContent = count;
        const disabled = count === 0 && !input.checked;
        input.disabled = disabled;
        label.classList.toggle('is-disabled', disabled);
      });
      const badge = root.querySelector(`[data-oo-filter-group="${group}"] [data-oo-group-count]`);
      if (badge) {
        badge.textContent = selected[group].size;
        badge.classList.toggle('is-active', selected[group].size > 0);
      }
    });
  };

  const cardMarkup = (product) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const firstVariant = variants[0];
    const availableVariants = variants.filter((variant) => variant.available);
    const quickVariant = variants.length === 1 && firstVariant?.available ? firstVariant : null;
    const price = productPrice(product);
    const comparePrice = firstVariant?.compare_at_price ? Number.parseFloat(firstVariant.compare_at_price) : null;
    const firstImage = Array.isArray(product.images) && product.images.length ? product.images[0] : null;
    const imageSrc = typeof firstImage === 'string' ? firstImage : firstImage?.src;
    const productUrl = `/products/${encodeURIComponent(product.handle)}`;
    const meta = [product._line, product._size].filter(Boolean).join(' · ');
    const image = imageSrc
      ? `<img class="oo-filter-card__image" src="${escapeHtml(imageSrc)}" alt="${escapeHtml(product.title)}" loading="lazy" width="600" height="600">`
      : '<span class="oo-filter-card__placeholder">Owls Oil</span>';

    let action = `<a class="oo-filter-card__view" href="${productUrl}">View product</a>`;
    if (quickVariant) {
      action = `
        <product-form data-section-id="owls-shop-all-filtering">
          <form method="post" action="/cart/add" class="form" data-type="add-to-cart-form">
            <input type="hidden" name="id" value="${escapeHtml(quickVariant.id)}" class="product-variant-id">
            <button type="submit" name="add" class="button button--secondary button--full-width" aria-live="polite">
              <span>Add to cart</span><span class="sold-out-message hidden">Sold out</span>
              <div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>
            </button>
          </form>
        </product-form>`;
    } else if (variants.length > 1 && availableVariants.length) {
      action = `<a class="oo-filter-card__view" href="${productUrl}">Choose options</a>`;
    }

    return `
      <li class="grid__item oo-filter-grid-item">
        <article class="oo-filter-card">
          <a class="oo-filter-card__image-wrap" href="${productUrl}">${image}</a>
          <div class="oo-filter-card__body">
            <span class="oo-filter-card__meta">${escapeHtml(meta)}</span>
            <h3 class="oo-filter-card__title"><a href="${productUrl}">${escapeHtml(product.title)}</a></h3>
            <p class="oo-filter-card__price">${money(price)}${comparePrice && comparePrice > price ? `<span class="oo-filter-card__compare">${money(comparePrice)}</span>` : ''}</p>
            <div class="oo-filter-card__action">${action}</div>
          </div>
        </article>
      </li>`;
  };

  const sortedProducts = (items) => {
    const sorted = [...items];
    switch (sortSelect?.value) {
      case 'title-asc': return sorted.sort((a, b) => a.title.localeCompare(b.title));
      case 'title-desc': return sorted.sort((a, b) => b.title.localeCompare(a.title));
      case 'price-asc': return sorted.sort((a, b) => productPrice(a) - productPrice(b));
      case 'price-desc': return sorted.sort((a, b) => productPrice(b) - productPrice(a));
      default: return sorted.sort((a, b) => a._index - b._index);
    }
  };

  const updateUrl = () => {
    const params = new URLSearchParams(window.location.search);
    GROUPS.forEach((group) => {
      params.delete(`oo_${group}`);
      if (selected[group].size) params.set(`oo_${group}`, [...selected[group]].join(','));
    });
    params.delete('oo_sort');
    if (sortSelect && sortSelect.value !== 'default') params.set('oo_sort', sortSelect.value);
    const query = params.toString();
    history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
  };

  const restoreFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    GROUPS.forEach((group) => {
      const raw = params.get(`oo_${group}`);
      const values = raw ? raw.split(',') : [];
      root.querySelectorAll(`[data-oo-filter-input="${group}"]`).forEach((input) => { input.checked = values.includes(input.value); });
    });
    const requestedSort = params.get('oo_sort');
    if (sortSelect && requestedSort && [...sortSelect.options].some((option) => option.value === requestedSort)) sortSelect.value = requestedSort;
    readSelectedFromInputs();
  };

  const render = (updateHistory = true) => {
    readSelectedFromInputs();
    const filtered = products.filter((product) => matches(product));
    const sorted = sortedProducts(filtered);
    grid.innerHTML = sorted.length
      ? sorted.map(cardMarkup).join('')
      : '<li class="oo-filter-empty"><strong>No products match those filters.</strong><span>Clear one or more selections to broaden the catalogue.</span></li>';
    if (status) status.textContent = `Showing ${filtered.length} of ${products.length} products`;
    const activeCount = GROUPS.reduce((sum, group) => sum + selected[group].size, 0);
    if (clearButton) clearButton.disabled = activeCount === 0;
    updateOptionCounts();
    if (updateHistory) updateUrl();
    document.documentElement.classList.add('oo-shop-all-ready');
  };

  clearButton?.addEventListener('click', () => {
    root.querySelectorAll('[data-oo-filter-input]:checked').forEach((input) => { input.checked = false; });
    if (sortSelect) sortSelect.value = 'default';
    render();
  });

  root.addEventListener('change', (event) => {
    if (event.target.matches('[data-oo-filter-input]') || event.target.matches('[data-oo-sort]')) render();
  });

  fetch(endpoint, { headers: { Accept: 'application/json' } })
    .then((response) => {
      if (!response.ok) throw new Error(`Catalogue request failed: ${response.status}`);
      return response.json();
    })
    .then((data) => {
      products = (data.products || []).map(normalizeProduct);
      if (!products.length) throw new Error('No storefront products returned');
      renderOptions();
      restoreFromUrl();
      render(false);
    })
    .catch((err) => {
      console.error('[Owls Shop All filters]', err);
      if (status) status.textContent = 'Standard catalogue view';
      if (error) error.hidden = false;
      root.querySelectorAll('.oo-shop-filter-group').forEach((group) => { group.hidden = true; });
      if (sortSelect) sortSelect.disabled = true;
      document.documentElement.classList.remove('oo-shop-all-filter-mode');
    });
})();